import React from "react";
import Icon from "./IconBase";

const Minus = (props) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m35.9 16.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-27.2q-0.8 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h27.2q0.9 0 1.5 0.6t0.6 1.5z" />
    </g>
  </Icon>
);

export default Minus;
